import { render, staticRenderFns } from "./ActivityCreateTabInformation.vue?vue&type=template&id=7976cc60&scoped=true&"
import script from "./ActivityCreateTabInformation.vue?vue&type=script&lang=js&"
export * from "./ActivityCreateTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCreateTabInformation.vue?vue&type=style&index=0&id=7976cc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976cc60",
  null
  
)

export default component.exports